import {SET_GAME_HISTORY} from "@actions/actionTypes";
import initialStore from "../initialStore";

export default function gameHistoryReducer(state = initialStore.gameHistory, action) {
    switch (action.type) {
        case SET_GAME_HISTORY:
            return {
                history : action.gameHistory.RoundModels.Items,
                _7DownPercentage: action.gameHistory._7DownPercentage,
                _7UpPercentage: action.gameHistory._7UpPercentage,
                _7Percentage: action.gameHistory._7Percentage
            }
        default:
            return state;
    }
}